// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2F_W9d__xOkCWl3Y_WOxqK{margin-bottom:3.2rem;margin-left:auto;margin-right:auto;text-align:center}._2Nv4Bmqs99orKUAWLjmxTh{margin-bottom:.8rem;margin-top:3.2rem}._2DxQmYICeKBWzw25HC67gd{height:100%;min-height:32rem;width:100%}._2DxQmYICeKBWzw25HC67gd .echarts{height:32rem;width:100%}@media screen and (min-width:480px){._2DxQmYICeKBWzw25HC67gd{min-height:40rem}._2DxQmYICeKBWzw25HC67gd .echarts{height:40rem}}._2DxQmYICeKBWzw25HC67gd .echarts>div{width:auto!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radar": "_2F_W9d__xOkCWl3Y_WOxqK",
	"radarTitle": "_2Nv4Bmqs99orKUAWLjmxTh",
	"echartsWrapper": "_2DxQmYICeKBWzw25HC67gd"
};
module.exports = ___CSS_LOADER_EXPORT___;
